import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import value from './value.js'

export default contract({
  value: array([
    value
  ])
})
